module.exports = __webpack_public_path__ + "static/media/blog_caro5.1cad2ebd.png";